import React, { useRef, useState } from 'react'
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import axiosInstance from '../../common/axios';
import useUpload from '../../hooks/useUpload';
import { getErrors, toastDefault } from '../../utils/handler.utils';
import Loader from '../Loader/Loader';

function AddNewCategory() {
    const name = useRef(null);
    const image = useRef(null);
    const sortOrder = useRef(null);
    const is_active = useRef(null);
    const description = useRef(null);

    const [categoryImage, setCategoryImage] = useState(null)
    const { path, uploading } = useUpload(categoryImage)

    const [loading, setLoading] = useState(null)
    const history = useHistory()

    const createPaymentMethodHandler = (e) => {
        e.preventDefault()

        if (!uploading) {
            setLoading(true)
            axiosInstance.post('/admin/category/create', {
                name: name.current.value,
                image: path,
                sort_order: sortOrder.current.value,
                description: description.current.value,
                is_active: is_active.current.checked ? 1 : 0,
            }).then(res => {
                toast.success('Category created successfully', toastDefault)

                setTimeout(() => {
                    history.push('/category')
                }, 1500);
            }).catch(err => {
                toast.error(getErrors(err, false, true), toastDefault)
                setLoading(false)
            })
        }
    }

    return (
        <section className="relative container_admin" >
            <div className="bg-white overflow-hidden rounded">
                <div className="px-6 py-3 border-b border-gray-200">
                    <h3 className="text-lg font-bold text-black">
                        Create new category
                    </h3>
                </div>
                <div className="py-10 px-4" >
                    <div className="w-full md:w-[70%] mx-auto py-6 relative border border-gray-200 px-4">
                        {loading && <Loader absolute />}
                        <form onSubmit={createPaymentMethodHandler} >
                            <div>
                                <div>
                                    <label htmlFor="name">Name</label>
                                    <input ref={name} id="name" className="form_input" type="text" placeholder="Name" required />
                                </div>
                                <div>
                                    <label htmlFor="description">Description</label>
                                    <input ref={description} id="description" className="form_input" type="text" placeholder="Description" />
                                </div>
                                <div>
                                    <label htmlFor="image">Image</label>
                                    <input ref={image} id="image" className="form_input" type="file" onChange={e => setCategoryImage(e.target.files[0])} />
                                </div>

                                <div className="form_grid">
                                    <div>
                                        <label htmlFor="sort_order">Sort Order</label>
                                        <input ref={sortOrder} id="sort_order" className="form_input" type="number" placeholder="Sort Number " required />
                                    </div>
                                </div>

                                <div className="cursor-pointer" >
                                    <input ref={is_active} id="is_active" type="checkbox" className="mr-2" />
                                    <label htmlFor="is_active" className="select-none cursor-pointer">Is Active</label>
                                </div>

                                <div className="mt-4">
                                    <button type="submit" disabled={uploading} className="cstm_btn w-full block">Create Category</button>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default AddNewCategory